function Cinema_form_booking(element) {
  this.element = element;
  this.toggler = document.querySelector('input#booking_form_toggler');

    this.init = function() {
      var that = this;
      this.element.addEventListener('click', function() {
        that.toggle(that.toggler);
      });
      this.toggle(document.querySelector('input#booking_form_toggler'));
    };

    this.toggle = function(element) {
      var cinema_regular = document.querySelector('.cinema-regular');
      if (element.checked) {
        cinema_regular.classList.add('hidden');
      } else {
        cinema_regular.classList.remove('hidden');
      }
    };
}
